const SERVER_URL_BY_ENV = {
  production: 'https://www.trainwithkickoff.com',
  beta: 'https://beta.trainwithkickoff.com',
  staging: 'https://staging.trainwithkickoff.com',
  growth: 'https://growth.trainwithkickoff.com',
  development: 'http://localhost:3000',
}

const SERVER_URL = SERVER_URL_BY_ENV[process.env.APP_ENV]

const NylasConfig = {
  clientId: process.env.NEXT_PUBLIC_NYLAS_CLIENT_ID,
  redirectUri: `${SERVER_URL}/oauth/nylas`,
  apiUri: 'https://api.us.nylas.com/v3',
  scope: ['calendar', 'openid'],
}

export default NylasConfig
